export default function OwnerStats({ stats }) {
    const cards = [
        { key: "today_orders", label: "طلبات اليوم", icon: "fa-receipt", value: stats?.today_orders },
        { key: "today_paid_orders", label: "مدفوعة اليوم", icon: "fa-circle-check", value: stats?.today_paid_orders },
        {
            key: "today_revenue",
            label: "إيرادات اليوم",
            icon: "fa-sack-dollar",
            value: stats ? `${Number(stats.today_revenue).toFixed(2)} ر.س` : undefined,
        },
        { key: "active_orders", label: "طلبات قيد التنفيذ", icon: "fa-fire-burner", value: stats?.active_orders },
    ];
    return (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mb-4" data-testid="owner-stats">
            {cards.map((c) => (
                <div key={c.key} className="surface-card p-3" data-testid={`stat-${c.key}`}>
                    <div className="text-text-muted text-xs flex items-center gap-1.5">
                        <i className={`fa-solid ${c.icon} text-brand`} /> {c.label}
                    </div>
                    <div className="text-xl font-black text-text-main mt-1" data-testid={`stat-${c.key}-value`}>
                        {c.value ?? "—"}
                    </div>
                </div>
            ))}
        </div>
    );
}
